<template>
  <div width="100%">
    <Breadcrumb :title="'Investor Report'"></Breadcrumb>

    <div class="row no-gutters">
      <div class="input-group mb-3 col-md-5 pl-0">
        <kendo-autocomplete
          id="SearchPartner"
          class="form-control"
          v-model="autoCompleteDisplayedValue"
          :data-source="partnerAutoCompleteSource"
          :data-text-field="'FullName'"
          :filter="'contains'"
          :placeholder="'Search for Partner'"
          @select="onAutoCompleteSelect"
        ></kendo-autocomplete>
        <div class="input-group-append">
          <span class="input-group-text">
            <i class="fa fa-search"></i>
          </span>
        </div>
      </div>
      <div class="form-group col-md-4">
        <div class="input-group">
          <kendo-datepicker
            placeholder="Select Date"
            :value="selectedDate"
            v-model="selectedDate"
            :format="'MM/dd/yyyy'"
            id="dtAsOfDate"
            @open="_setCurrentDateifNull"
          ></kendo-datepicker>
        </div>
      </div>
    </div>

    <div class="row no-gutters">
      <InvestorPartnerInfoForm
        :PartnerModalLabel="partnerModalConfig"
        :PartnerInfoFormConfig="PartnerInfo"
        :InvesterData="InvestorInfo"
        :disabled="true"
        v-show="formDisplay"
      ></InvestorPartnerInfoForm>
    </div>

   
  </div>
</template>

<script>
import $ from "jquery";
import _ from "lodash";
import moment from "moment";

import BaseGrid from "@/components/base/BaseGrid.vue";
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import toolbarUtility from "@/services/toolbarUtility.js";
import funcUtil from "@/services/funcUtil.js";
import apiUtil from "@/services/apiUtil.js";
import deepGroupBy from "@/services/groupByUtil.js";
import BaseModelInputControl from "@/models/BaseModelInputControl.js";
import BaseModelIssuance from "@/models/BaseModelIssuance.js";
import {
  InvestorGridConfig,
  InvestorDetailToolBarConfig
} from "./InvestorReportConfig.js";
import BuyoutMixin from "@/mixins/Buyout.js";
import VestingScheduleDatesMixin from "@/mixins/VestingScheduleDatesMixin.js";
import InvestorPartnerInfoForm from "@/components/forms/InvestorPartnerInfoForm.vue";
import BaseModelPartner from "@/models/BaseModelPartner.js";
import BaseModelPartnerAffiliation from "@/models/BaseModelPartnerAffiliation.js";
import BaseModelBuyout from "@/models/BaseModelBuyout.js";
import { mapGetters, mapActions, mapState } from "vuex";
import { isNullOrUndefined } from "util";
import BaseModelProgram from "@/models/BaseModelProgram.js";
import BaseModelTransfer from "@/models/BaseModelTransfer.js";
import BaseModelVesting from "@/models/BaseModelVesting.js";
import BaseModelVestingSchedule from "@/models/BaseModelVestingSchedule.js";
import BaseModelUnitClass from "@/models/BaseModelUnitClass.js";
import BaseModelTransactionLog from "@/models/BaseModelTransactionLog.js";
import BaseModelDistribution from "@/models/BaseModelDistribution.js";
import BaseModelAllocation from "@/models/BaseModelAllocation.js";
import PartnerInvestorMixin from "@/mixins/PartnerInvestorMixin.js";
import BaseInvestmentValuation from "@/models/BaseModelInvestmentValuation.js";

export default {
  name: "InvestorReport",
  mixins: [toolbarUtility, apiUtil, funcUtil, BuyoutMixin, VestingScheduleDatesMixin, PartnerInvestorMixin],
  computed: {
    ...mapGetters("getModule", [
      "withFilter",
      "getJoinedItemsFilter",
      "getAllItemFilter",
      "GetValueByKey"
    ]),
    ...mapState("postModule", ["response"])
  },

  components: {
    Breadcrumb,
    InvestorPartnerInfoForm,
    BaseGrid,
    BaseToolBar
  },

  data: function() {
    return {
      InvestorGridConfig: InvestorGridConfig,
      InvestorDetailToolBarConfig: InvestorDetailToolBarConfig,
      BaseModelPartner: BaseModelPartner,
      BaseModelPartnerAffiliation: BaseModelPartnerAffiliation,
      BaseModelInputControl: BaseModelInputControl,
      BaseModelBuyout: BaseModelBuyout,
      BaseModelIssuance: BaseModelIssuance,
      BaseModelProgram: BaseModelProgram,
      BaseModelTransfer: BaseModelTransfer,
      BaseModelVesting: BaseModelVesting,
      BaseModelVestingSchedule: BaseModelVestingSchedule,
      BaseModelUnitClass: BaseModelUnitClass,
      BaseModelTransactionLog: BaseModelTransactionLog,
      BaseModelDistribution: BaseModelDistribution,
      BaseInvestmentValuation: BaseInvestmentValuation,
      partnerModalConfig: {
        modalName: "Partner Detail",
        modalAddorEdit: ""
      },
      ProgramInfo: { parent: {}, children: {} },
      partnerId: this.$route.params.partnerId,
      selectedDate: null,
      formDisplay: false,
      autocompleteValue: "",
      autoCompleteDisplayedValue: "",
      partnerAutoCompleteSource: [],
      PartnerInfo: { parent: {}, children: {} },
      InvestorInfo: [],
      displayFields: {
        TerminationDate: ""
      },
      classRunningTotalDict: {},
        ExceptionProgram : {
          "Master" : {"Id" : 81,"ProgramID" : 30010, "InvestmentId" : 49,"InvestmentInvestmentId" : 500010},
          "Child" : {"Id" : 82,"ProgramID" : 30011, "InvestmentId" : 50,"InvestmentInvestmentId" : 500011}
        },
      ProgramAPIData: [],
      InvestmentValuationAPIData: []
    };
  },

  mounted() {
    let self = this;
    self.displayFields.TerminationDate = self.GetValueByKey(
      "BuyoutTerminationDate"
    );
    if (self.displayFields.TerminationDate != "") {
      let date = new Date(self.displayFields.TerminationDate);
      self.displayFields.TerminationDate = moment(
        String(date.toISOString())
      ).format("MM/DD/YYYY");
    }
    $("#dtAsOfDate").kendoDatePicker({
      change: function() {
        self.selectedDate = this.value();
        self.getPartnerInformation();
        self.getPartnerProgramData();
      }
    });
    this.getPartnerAutoCompleteData();

    this.ShowAutoCompleteListOnFocus("SearchPartner");

    if (this.partnerId) {
      this.formDisplay = true;

      this.getPartnerInformation();
      this.getPartnerProgramData();
       $("#summaryView")[0].checked = true; //By Deafult Summary View Should be Selected when Chnaging Programs.
    }
  },

  beforeRouteUpdate(to, from, next) {
    this.partnerId = to.params.partnerId;
    if (this.partnerId) {
      this.formDisplay = true;
      this.getPartnerInformation();
      this.getPartnerProgramData();
      $("#summaryView")[0].checked = true; //By Deafult Summary View Should be Selected when Chnaging Programs.
    } else {
      this.autoCompleteDisplayedValue = "";
      this.formDisplay = false;
    }
    next();
  },

  methods: {
    ...mapActions("postModule", [""]),

    getPartnerAutoCompleteData() {
      var partnerAPIData = this.withFilter(BaseModelPartner.list);
      this.partnerAutoCompleteSource = _.filter(partnerAPIData, function(o) {
        return o.FullName != "Treasury Units";
      });
    },

    onAutoCompleteSelect(e) {
      this.autocompleteValue = e.dataItem.Id;
      this.partnerId = e.dataItem.Id;
      this.$router.push({
        name: "InvestorReport",
        params: { partnerId: this.partnerId }
      });
    },

    getPartnerInformation() {
      const self = this;

      if (self.selectedDate == null) {
        self.selectedDate = new Date();
      }
      if (self.partnerId) {
        var storeResponse = this.getJoinedItemsFilter({
          parentConfig: BaseModelPartner,
          parentId: self.partnerId,
          keyToJoin: "Partner/Id",
          childConfigs: [BaseModelPartnerAffiliation]
        });
        storeResponse["selectedDate"] = self.selectedDate;
        console.log("Partner", storeResponse);
        let response = JSON.parse(JSON.stringify(storeResponse));
        self.PartnerInfo = response;
        console.log(response);
      }
    },

    getDateDiffinDays: function(date1, date2) {
      let dt1 = new Date(date1);
      let dt2 = new Date(date2);
      return Math.floor(
        (Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate()) -
          Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate())) /
          (1000 * 60 * 60 * 24)
      );
    },

   

    async getPartnerProgramData() {
      const self = this;
      self.ProgramDetailGridData = [];
      self.InvestorInfo = [];
      let partnerID = [];
      var taxYearQuarter = self.getTaxYearQuarter(self.selectedDate);   
      let InvestmentValuation = self.withFilter(self.BaseInvestmentValuation.list);
      partnerID.push({ PartnerId: self.partnerId });

      var objPtr = this.partnerAutoCompleteSource.filter(x => x.Id == self.partnerId);

      //var d = new Date(self.selectedDate);
      /*
      if(objPtr[0].LeaveDate != null)
      {
        if (self.selectedDate > objPtr[0].LeaveDate)
        {
          self.selectedDate = objPtr[0].LeaveDate;
        }
      }
      */

      if(objPtr[0].LeaveDate != null)
      {
        var xLeaveDate = new Date(objPtr[0].LeaveDate);
        if (self.selectedDate > xLeaveDate)
        {
          self.selectedDate = xLeaveDate;
        }
      }

      let filteredBuyoutData = self.startBuyoutProcess(
        partnerID,
        self.selectedDate
      );

      let ClonedBuyout = _.clone(filteredBuyoutData);
      let groupedProgramId = _.groupBy(filteredBuyoutData, "ProgramId");
      _.forEach(groupedProgramId, function(ProgramVal, ProgramKey) {
        if (
          groupedProgramId &&
          groupedProgramId[ProgramKey] &&
          groupedProgramId[ProgramKey].length > 1
        ) {
          let groupedUnitClass = _.groupBy(
            groupedProgramId[ProgramKey],
            "UnitClass"
          );
          _.forEach(groupedUnitClass, function(ClassVal, ClassKey) {
            if (
              groupedUnitClass &&
              groupedUnitClass[ClassKey] &&
              groupedUnitClass[ClassKey].length > 1
            ) {
              let groupedUnitType = _.groupBy(
                groupedUnitClass[ClassKey],
                "UnitType"
              );
              _.forEach(groupedUnitType, function(TypeVal, TypeKey) {
                if (
                  groupedUnitType &&
                  groupedUnitType[TypeKey] &&
                  groupedUnitType[TypeKey].length > 1
                ) {
                  let groupedVestingType = _.groupBy(
                    groupedUnitType[TypeKey],
                    "VestingType"
                  );
                  _.forEach(groupedVestingType, function(VestVal, VestKey) {
                    if (
                      groupedVestingType &&
                      groupedVestingType[VestKey] &&
                      groupedVestingType[VestKey].length > 1
                    ) {
                      _.remove(filteredBuyoutData, function(x) {
                        return (
                          x.UnitClass ==
                            groupedVestingType[VestKey][0].UnitClass &&
                          x.UnitType ==
                            groupedVestingType[VestKey][0].UnitType &&
                          x.VestingType ==
                            groupedVestingType[VestKey][0].VestingType &&
                          x.PartnerId ==
                            groupedVestingType[VestKey][0].PartnerId &&
                          x.ProgramId ==
                            groupedVestingType[VestKey][0].ProgramId
                        );
                      });
                      groupedVestingType[VestKey][0].Unit = _.sumBy(
                        groupedVestingType[VestKey],
                        "Unit"
                      );
                      /*
                      groupedVestingType[VestKey][0].VestedUnit = _.sumBy(
                        groupedVestingType[VestKey],
                        "VestedUnit"
                      );
                      */
                      filteredBuyoutData.push(groupedVestingType[VestKey][0]);
                    }
                  });
                }
              });
            }
          });
        }
      });

      //let vestingList =  self.withFilter(self.BaseModelVesting.list);
      let issuanceList = self.withFilter(self.BaseModelIssuance.list);
      let programList = self.withFilter(self.BaseModelProgram.list);
      //let transferList = self.withFilter(self.BaseModelTransfer.list);

      //sum of awardunits
      var localProgramSumAwardedUnits = window.linq
        .from(filteredBuyoutData)
        .groupBy(
          "$.ProgramId",
          null,
          "{ProgramId: $, AmountPaidForProgram: $$.first(), SumofAwardedUnits: $$.sum('Number($.Unit)')}"
        )
        .toArray();
      // console.log(localProgramSumAwardedUnits);

      var localFirstAmountPaidForProgram = 0;

      //filteredBuyoutData = {program 1, unit 50}, {program 1, unit 50}, {program 2, unit 50}
      // localProgramSumAwardedUnits = {program 1, sum 100}, {program 2, sum 50}
      if (filteredBuyoutData.length && localProgramSumAwardedUnits.length) {
        for (var i = 0; i < filteredBuyoutData.length; i++) {
          var result = localProgramSumAwardedUnits.filter(function(obj) {
            return (
              obj.ProgramId.toString()
                .trim()
                .toLowerCase() ==
              filteredBuyoutData[i].ProgramId.toString()
                .trim()
                .toLowerCase()
            );
          })[0];

          if (result) {
            filteredBuyoutData[i].UnitPrice = 0;
            localFirstAmountPaidForProgram = 0;

            let ProgramDetailData = {};
            ProgramDetailData.Id = filteredBuyoutData[i].Id;
           
            var selectedProgram = programList.filter(x => x.Id == filteredBuyoutData[i].ProgramId);
            

            ProgramDetailData.ProgramName =
              !isNullOrUndefined(selectedProgram) && selectedProgram.length > 0
                ? selectedProgram[0].Title
                : "";

            self.PartnerName = ProgramDetailData.PartnerName =
              filteredBuyoutData[i].PartnerFullName;

            ProgramDetailData.ProgramId = filteredBuyoutData[i].ProgramId;
            ProgramDetailData.PartnerId = filteredBuyoutData[i].PartnerId;
            ProgramDetailData.PartnerLeaveDate =
              filteredBuyoutData[i].PartnerLeaveDate;
            ProgramDetailData.UnitPool = filteredBuyoutData[i].UnitPool;
            ProgramDetailData.UnitType = filteredBuyoutData[i].UnitType;
            ProgramDetailData.UnitClass = filteredBuyoutData[i].UnitClass;
            ProgramDetailData.UnitPrice = filteredBuyoutData[i].UnitPrice;
            ProgramDetailData.VestingType = filteredBuyoutData[i].VestingType;
            ProgramDetailData.AwardedUnits = filteredBuyoutData[i].Unit;
            ProgramDetailData.TotalUnits = filteredBuyoutData[i].Unit;
            ProgramDetailData.VestedUnits = !isNullOrUndefined(
              filteredBuyoutData[i].VestedUnit
            )
              ? filteredBuyoutData[i].VestedUnit
              : 0;

            ProgramDetailData.AmountPaidForProgram = localFirstAmountPaidForProgram;
            ProgramDetailData.SumofAwardedUnits = result.SumofAwardedUnits;
            ProgramDetailData.Forfeiture = 0;

            var selectedIssuance = issuanceList.filter(
              x =>
                x.ProgramId == ProgramDetailData.ProgramId &&
                x.ReceiverId == ProgramDetailData.PartnerId &&
                x.VestingType == ProgramDetailData.VestingType &&
                x.UnitClass == ProgramDetailData.UnitClass &&
                x.UnitType == ProgramDetailData.UnitType
            );

            //   var selectedIssuance =  issuanceList.filter(x => x.ProgramId == ProgramDetailData.ProgramId && x.ReceiverId == ProgramDetailData.PartnerId
            //   && x.VestingType == ProgramDetailData.VestingType && x.UnitClass == ProgramDetailData.UnitClass && x.UnitType == ProgramDetailData.UnitType);

            //   if (!isNullOrUndefined(selectedIssuance) && selectedIssuance.length > 0) {
            //  ProgramDetailData.Issuance = !isNullOrUndefined(selectedIssuance) && selectedIssuance.length > 0 && selectedIssuance[0].Unit > 0 ? selectedIssuance[0].Unit : 0;
            //   }

            //  var selectedTransfer =  transferList.filter(x => x.ProgramId == ProgramDetailData.ProgramId && x.SenderId == ProgramDetailData.PartnerId
            //  && x.VestingType == ProgramDetailData.VestingType && x.UnitClass == ProgramDetailData.UnitClass && x.UnitType == ProgramDetailData.UnitType);

            // if (!isNullOrUndefined(selectedTransfer) && selectedTransfer.length > 0) {
            // ProgramDetailData.Transfer = !isNullOrUndefined(selectedTransfer) && selectedTransfer.lengrh > 0 && selectedTransfer[0].Unit > 0 ? selectedTransfer[0].Unit : 0;
            // }

            // var selectedTRansferLog = transactionLogList.filter(x => x.BusinessEvent == "Forfeiture" && x.ProgramId == ProgramDetailData.ProgramId && x.PartnerId == ProgramDetailData.PartnerId
            //  && x.VestingType == ProgramDetailData.VestingType && x.UnitClass == ProgramDetailData.UnitClass && x.UnitType == ProgramDetailData.UnitType);

            //  if(!isNullOrUndefined(selectedTRansferLog) && selectedTRansferLog.length > 0){
            //   ProgramDetailData.Forfeiture = selectedTRansferLog.Unit;
            // }
            // else {
            //      ProgramDetailData.Forfeiture = 0;
            // }
            var standardUnits = this.getUnitCalculationByProgram(
              ProgramDetailData.ProgramId,
              ProgramDetailData.PartnerId,
               ProgramDetailData.UnitClass,
                ProgramDetailData.VestingType
            );

            if (!isNullOrUndefined(standardUnits) && standardUnits.length > 0) {
              ProgramDetailData.Issuance = standardUnits[0].StandardIssuance;
              ProgramDetailData.Transfer = standardUnits[0].StandardTransfer;
              ProgramDetailData.Forfeiture =
                standardUnits[0].StandardForfeiture;
              ProgramDetailData.OwnershipExcludingTreasuryUnits =
                standardUnits[0].TaxOwnership;
              ProgramDetailData.OwnershipIncludingTreasuryUnits =
                standardUnits[0].FMVOwnership;
            } else {
              ProgramDetailData.Issuance = 0;
              ProgramDetailData.Transfer = 0;
              ProgramDetailData.OwnershipExcludingTreasuryUnits = 0;
              ProgramDetailData.OwnershipIncludingTreasuryUnits = 0;
            }
            // Percentage overflow, infinity bug fix
            // from : filteredBuyoutData[i].VestedUnit / filteredBuyoutData[i].Unit
            // to : filteredBuyoutData[i].VestedUnit / standardUnits[0].StandardIssuance
            // Added : fix to two decimal to avoid 99.xx or 100.xx % 
            //console.log("calc vesting",selectedIssuance[0]);
            if(!isNullOrUndefined(selectedIssuance) &&
              selectedIssuance.length > 0) 
              {
            ProgramDetailData.VestPercentage = this.calculateVestPercentage(selectedIssuance[0]);
              } else {
                ProgramDetailData.VestPercentage = 0
                ProgramDetailData.VestPercentage = (ProgramDetailData.VestedUnits / ProgramDetailData.TotalUnits);
             
              }
            

            /*
              ProgramDetailData.Forfeiture != 0
              ? 1
              : !isNullOrUndefined(filteredBuyoutData[i].VestedUnit)
              ? filteredBuyoutData[i].VestedUnit.toFixed(2) / standardUnits[0].StandardIssuance.toFixed(2)
              : 0;
            */
            if (
              !isNullOrUndefined(selectedIssuance) &&
              selectedIssuance.length > 0
            ) {
              ProgramDetailData.NextVestingDate = this.calcualateNextVestedDate(
                ProgramDetailData.VestPercentage * 100,
                new Date(selectedIssuance[0].VestStartDate)
              );
            } else {
              ProgramDetailData.NextVestingDate = "N/A";
            }

            let lclFMVSDistribution = this.getPartnerDistribution(
              filteredBuyoutData[i].PartnerId,
              filteredBuyoutData[i].ProgramId,
              self.selectedDate
            );
            //let filterQuery;
            // let invesmentId = _.filter(programList,function(obj){
            //   return obj.Id == filteredBuyoutData[i].ProgramId
            // })
            let investmentId = 0; 
            programList.forEach(item => {
              if(item.Id == filteredBuyoutData[i].ProgramId) {
                investmentId  = item.InvestmentInvestmentID;
                return;
              }
            });
            // let investmentId = programList.filter(x => {
            //   return (x.ProgramID == filteredBuyoutData[i].ProgramId)
            // });

            var taxYearQuarter = self.getTaxYearQuarter(self.selectedDate);
            if(filteredBuyoutData[i].ProgramId == self.ExceptionProgram.Child.Id) {
              investmentId = self.ExceptionProgram.Master.InvestmentInvestmentId; 
              // filterQuery = {
              //   filter : "InvestmentId eq" + self.ExceptionProgram.Master.InvestmentId +" and TaxYearQuarter eq  " +  taxYearQuarter
              // };
            } 
            // else {



            // }

            
            // var test = _.filter(self.BaseInvestmentValuation.list, function(obj){
            //   return(
            //     obj.InvestmentInvestmentID == investmentId
            //       && obj.TaxYearQuarter === taxYearQuarter
            //   );
            // })
            // console.log("lodash",test);
            //  console.log(
            //    "vd",valuationData
            //  );
            //console.log("valuationData",InvestmentValuation);

            // var test = _.filter(self.BaseInvestmentValuation, function(obj){
            //   console.log("V",console.log(obj));
            //   if(obj.InvestmentInvestmentID) {
            //     return (obj.InvestmentInvestmentID.toString()
            //       .trim()
            //       .toLowerCase() == investmentId.toString()
            //       .trim()
            //       .toLowerCase() && obj.TaxYearQuarter.toString()
            //       .trim()
            //       .toLowerCase() == taxYearQuarter.toString()
            //       .trim()
            //       .toLowerCase())
            //   }

            // })
            //console.log("valuation data",test);            
            let lclFMVSValue = {
              "ProjectedValue" : 0,
              "CurrentValue" : 0
            };
            let pv = 0;
            let cv = 0;
            InvestmentValuation.forEach(obj => {
              //console.log("V",console.log(obj.InvestmentInvestmentID,obj.TaxYearQuarter,obj));
              if(obj.InvestmentInvestmentID == investmentId
                  && obj.TaxYearQuarter === taxYearQuarter) {
                  lclFMVSValue.ProjectedValue = obj.ProjectedValue;
                  lclFMVSValue.CurrentValue = obj.CurrentValue;                    
                  //console.log("Valuation Values",obj,lclFMVSValue);
                } 
            })
            // filterQuery = {
            //   filter : "InvestmentInvestmentID eq " +  investmentId +" 'and' TaxYearQuarter eq " + taxYearQuarter
            // };            
            // let valuationData = self.withFilter(self.BaseInvestmentValuation,filterQuery);

            // InvestmentValuation.forEach(item => {
            //   if(item.InvestmentInvestmentID == investmentId &&
            //     item.TaxYearQuarter === taxYearQuarter) {
            //       lclFMVSValue.ProjectedValue = item.ProjectedValue;
            //       lclFMVSValue.CurrentValue = item.CurrentValue;
            //   } else {
            //     lclFMVSValue.ProjectedValue = 0;
            //     lclFMVSValue.ProjectedValue = 0;
            //   }
            // });

            console.log("lclFMVSValue",lclFMVSValue,ProgramDetailData.OwnershipIncludingTreasuryUnits);
            // let lclFMVSValue = this.getInvestorValuation(
            //   filteredBuyoutData[i].PartnerId,
            //   selectedProgram[0].InvestmentId,
            //   self.selectedDate
            // );



            ProgramDetailData.CumulativeDistribution = lclFMVSDistribution;
            ProgramDetailData.PotentialValue =
               lclFMVSValue.ProjectedValue *ProgramDetailData.OwnershipIncludingTreasuryUnits;
            ProgramDetailData.LiquidationValue = lclFMVSValue.CurrentValue * ProgramDetailData.OwnershipIncludingTreasuryUnits;
            // ProgramDetailData.VestedPercent =
            //   filteredBuyoutData[i].VestedUnit / filteredBuyoutData[i].Unit;

            ProgramDetailData.UnitsToBeRetained = 0;

            //vested units + units to be retained
            ProgramDetailData.TotalUnitsToBeRetained =
              filteredBuyoutData[i].VestedUnit +
              ProgramDetailData.UnitsToBeRetained;

            //Awarded Units - Total Units to be retained
            // ProgramDetailData.Forfeiture =
            //   ProgramDetailData.AwardedUnits -
            //   ProgramDetailData.TotalUnitsToBeRetained;

            //Unit Price x Total Units to be retained:
            ProgramDetailData.AmountPayable = isNaN(
              parseInt(
                filteredBuyoutData[i].UnitPrice *
                  ProgramDetailData.TotalUnitsToBeRetained
              )
            )
              ? 0
              : parseInt(
                  filteredBuyoutData[i].UnitPrice *
                    ProgramDetailData.TotalUnitsToBeRetained
                );

            //unit price x units to be forfeited
            ProgramDetailData.AmountReceivable = isNaN(
              parseInt(
                filteredBuyoutData[i].UnitPrice *
                  (filteredBuyoutData[i].Unit -
                    ProgramDetailData.TotalUnitsToBeRetained)
              )
            )
              ? 0
              : parseInt(
                  filteredBuyoutData[i].UnitPrice *
                    (filteredBuyoutData[i].Unit -
                      ProgramDetailData.TotalUnitsToBeRetained)
                );

            //Amount Paid For Program x (awarded units / (sum of awarded units for the program))
            ProgramDetailData.AmountPaid =
              localFirstAmountPaidForProgram *
              (filteredBuyoutData[i].Unit / result.SumofAwardedUnits);

            //max(0, amount paid - amount payable)
            ProgramDetailData.Buyout =
              ProgramDetailData.AmountPaid - ProgramDetailData.AmountPayable > 0
                ? ProgramDetailData.AmountPaid - ProgramDetailData.AmountPayable
                : 0;

            //max(0, amount payable - amount paid)
            ProgramDetailData.AmountOwedToPartnership =
              ProgramDetailData.AmountPayable - ProgramDetailData.AmountPaid > 0
                ? ProgramDetailData.AmountPayable - ProgramDetailData.AmountPaid
                : 0;

            //amount receivable - buyout
            ProgramDetailData.ContributionRelief =
              ProgramDetailData.AmountReceivable - ProgramDetailData.Buyout;

            //buyout - amount owed to partnership
            ProgramDetailData.NetPayout =
              ProgramDetailData.Buyout -
              ProgramDetailData.AmountOwedToPartnership;

            // ProgramDetailData.Status = filteredBuyoutData[i].Status;
            // ProgramDetailData.WorkflowStatus =
            //filteredBuyoutData[i].WorkflowStatus;

            self.InvestorInfo.push(ProgramDetailData);
          }
        }
        // console.log(self.ProgramDetailGridData);
      }
    },

    calcualateNextVestedDate(vestingpercentage, vestedDate) {
      let self = this;
      if(vestingpercentage < 25){
        return self._convertTimeZone(new Date(vestedDate.setMonth(vestedDate.getMonth()+12)));
      }
     else if(vestingpercentage >= 25 && vestingpercentage < 50) {
       return self._convertTimeZone(new Date(vestedDate.setMonth(vestedDate.getMonth()+24)));
     }
     else if(vestingpercentage >= 50 && vestingpercentage < 75) {
        return self._convertTimeZone(new Date(vestedDate.setMonth(vestedDate.getMonth()+36)));
     }
    else if(vestingpercentage >= 75 && vestingpercentage < 99) {
        return self._convertTimeZone(new Date(vestedDate.setMonth(vestedDate.getMonth()+48)));
    }
    else{
      return "N/A";
    }
    },

    calculateVestPercentage(element) {
          if (!this.isRetired(element.ReceiverId)) {
          if (element.VestingType=="Standard") {
            let vestStartDate = moment(element.VestStartDate);
            let dateToCompare = moment(this.selectedDate);
            let yearDiff=dateToCompare.diff(vestStartDate, 'years');
            switch (true) {
              case (yearDiff==1):
                return 0.25
                break;
              case (yearDiff==2):
                return 0.50
                break;
              case (yearDiff==3):
                return 0.75
                break;
              case (yearDiff>=4):
                return 1
                break;    
              default:
                return
                break;
            }
          }else if(element.VestingType=="Cliff" ){
            let cliffDate = moment(element.VestCliffDate).unix();
            if(cliffDate > 0 && moment(element.VestCliffDate)< moment(this.selectedDate)) {
              return 1;
            } else {
              return 0;
            }
          }
        }
        //This is for Accelerated VEsting for Retired Employee : Vest 100%
        else{
          if(element.VestingType=="Cliff") {
            let cliffDate = moment(element.VestCliffDate).unix();
            if(cliffDate < 0) {
              return 0;
            } else {
              return 1;
            }
          } else {
          return 1;
          }
        }      
    },
    isRetired(partnerId) {
        let query = {
          batchQuery: true,
          filter: function(o) {
            return (
              o.Id == partnerId &&
              ( o.StartBuyout=="Completed" || o.StartBuyout == "Completed" ||  o.PartnerStatus === "Retired Employee" ||
                o.PartnerStatus === "Retired Family Member" )
            );
          }
        };
        let partnerResult=this.withFilter(BaseModelPartner.list,query)
          if(partnerResult && partnerResult.length>0) {
            return true;
          } else {
            return false;
          }
    },

  }
};
</script>

<style scoped>
.k-widget.k-autocomplete.k-header.k-state-default {
  width: 250px;
  background-color: yellow;
}
</style>
